import { createAnonAxios } from "./vg2AnonAxios";
export { agisciOpIdForDecision } from "./vg2AgisciOpId";

const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;
const api = createAnonAxios(API_V2);

export const generateActionPlan = async (caseId, operationId) =>
  (await api.post(`/cases/${caseId}/action-plan/generate`,
    { operation_id: operationId })).data;

export const getActionPlan = async (caseId) =>
  (await api.get(`/cases/${caseId}/action-plan`)).data;

const OP_ID_PREFIX = "vg2_agisci_op_";

export function agisciOpIdKey(caseId, ownerDecisionId) {
  return `${OP_ID_PREFIX}${caseId}_${ownerDecisionId}`;
}

export function getAgisciOpId(caseId, ownerDecisionId) {
  const key = agisciOpIdKey(caseId, ownerDecisionId);
  let op = localStorage.getItem(key);
  if (!op) {
    op = "aop_" + Math.random().toString(36).slice(2, 14);
    localStorage.setItem(key, op);
  }
  return op;
}

// §LAUNCH-B3 · Op-id DETERMINISTICO legato allo scenario scelto e alla
// versione di DECIDI — definito in ./vg2AgisciOpId (ri-esportato sopra per
// mantenere invariati gli import esistenti).
